import { noop } from "@silo/utils";
import { Menu, MenuButton, MenuItem, MenuItemLink, MenuList } from "../../menu";
import { ExternalLinkIcon } from "../../../icons/external-link";
import { LINKS } from "@silo/types";

export function VersionMenu(): JSX.Element {
  return (
    <Menu id="version-menu" selectedId="1" setSelectedId={noop}>
      <div>
        <MenuButton className="w-full px-2.5" variant="tertiary">
          v1
        </MenuButton>

        <MenuList className="z-50">
          <MenuItem id="1">Silo v1</MenuItem>

          <MenuItemLink href={LINKS.V2} id="2">
            <div className="flex items-center gap-2.5">
              Silo v2
              <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
            </div>
          </MenuItemLink>

          <MenuItemLink href={LINKS.V3} id="3">
            <div className="flex items-center gap-2.5">
              Silo v3
              <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
            </div>
          </MenuItemLink>
        </MenuList>
      </div>
    </Menu>
  );
}
